import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=31994742&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"
import style0 from "./Sign.vue?vue&type=style&index=0&id=31994742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31994742",
  null
  
)

export default component.exports